import React from "react";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { IoPlayOutline } from "react-icons/io5";
import { IoIosTimer } from "react-icons/io";

import { PALETTE } from "../../common/ThemeConstants";

export default function CardRest({
  rest,
  onPlayClicked,
  active = false,
  width = 100,
}) {

  return (
    <div className={`my-1 rounded-md`}>
      <Row
        className="g-0 align-items-center rounded-md py-2"
        style={{
          background: PALETTE.WHITE,
        }}
      >
        <Col xs={4} className="align-self-center">
          <div className="text-center" style={{ width: width }}>
            <IoIosTimer
              size={32}
              color={PALETTE.DARKGRAY}
              style={{ opacity: active ? 1 : 0.3, }}
            />
          </div>
        </Col>
        <Col
          xs={6}
          className="text-start align-self-center px-0"
          style={{
            paddingLeft: "20px",
            opacity: active ? 1 : 0.3,
          }}>
          <p style={{ marginBottom: "2px", fontWeight: "bold" }}>
            Riposo
          </p>
          <p className="cardDescription mb-2" style={{ fontSize: "0.9rem", color: PALETTE.DARKGRAY }}>
            Riposa per {rest} secondi
          </p>
        </Col>
        <Col xs={2} className="align-self-center text-center">
          <IoPlayOutline
            className="align-items-center text-center m-auto"
            style={{
              cursor: active ? "pointer" : "default",
              opacity: active ? 1 : 0.3,
            }}
            color={PALETTE.TRUEGRAY}
            size={28}
            onClick={active ? () => onPlayClicked(rest) : () => { }}
          />
        </Col>
      </Row>
    </div>
  );
}
